import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const FULLSCREEN_ROUTES = new Set(['/play', '/practice']);

/** Lock body scroll on full-viewport play screens */
export function BodyRouteClass() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.body.classList.toggle('route-play', FULLSCREEN_ROUTES.has(pathname));
    return () => document.body.classList.remove('route-play');
  }, [pathname]);

  return null;
}
